<template>
    <v-dialog v-model="shows" width="560">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card v-if="gift">
            <v-card-title class="subtitle-1">
                캐시 선물 내역
                <v-spacer />
                <v-icon @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text class="py-4">
                <v-row class="ma-n2">
                    <v-col class="pa-2" cols="12">
                        <v-simple-table dense class="v-sheet--outlined">
                            <tbody>
                                <tr v-for="{ term, description } in details" :key="term">
                                    <th width="120" class="text-caption grey lighten-4">{{ term }}</th>
                                    <td class="text-caption">{{ description }}</td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        gift: { type: Object, default: null },
    },
    data: () => ({
        shows: false,
    }),
    computed: {
        details() {
            const { sender, receiver, amount, status, createdAt, takedAt } = this.gift || {};

            return [
                { term: "보낸 사람", description: sender?.name ? `${sender.name}(${sender.username || "-"})` : "-" },
                { term: "보낸 일자", description: createdAt?.toDateTime?.() || "-" },
                { term: "금액", description: `${(+amount || 0).format()}원` },
                { term: "상태", description: status || "-" },
                { term: "받는 사람", description: receiver?.name ? `${receiver.name}(${receiver.username || "-"})` : "-" },
                { term: "받은 일자", description: takedAt?.toDateTime?.() || "-" },
            ];
        },
    },
};
</script>

<style lang="scss" scoped></style>
